import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import { useState } from "react";
import {
  UpdateCustomerReferenceRequest,
  useRltWorkOrderUpdateCustomerReferenceMutation,
} from "@/services/backend/rlt/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import {
  errorsFor,
  useErrDocumentNotReady,
} from "@/shared/bsm/core/document/components/ui/err-document-not-ready";
import { fieldErrors } from "@/shared/lib/errors/validation-error";
import t from "@/lang/lang";
import { TextInput } from "@/shared/components/form/text-input";

export function WorkOrderCustomerReferenceInput({
  workOrder,
  disabled,
}: {
  workOrder: WorkOrder;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateCustomerReferenceRequest>({
    id: workOrder.id,
    customerReference: workOrder.customerReference,
  });
  const mutation = useRltWorkOrderUpdateCustomerReferenceMutation();
  const { error } = useDebouncedMutation(request, setRequest, mutation, {
    id: workOrder.id,
    customerReference: workOrder.customerReference,
  });

  const { notReadyError, resetNotReadyErrorField } = useErrDocumentNotReady();

  const errors = [
    ...(errorsFor(notReadyError, "customerReference") ?? []),
    ...(fieldErrors(error, "customerReference") ?? []),
  ];

  return (
    <TextInput
      label={t("Kundenreferenz")}
      field="customerReference"
      text={request.customerReference}
      onTextChange={(customerReference) => {
        setRequest({ ...request, customerReference });
        resetNotReadyErrorField("customerReference");
      }}
      errors={errors}
      disabled={disabled}
    />
  );
}
